<template>
  <div>
    <Player
      v-if="version === 3 && isReady && podcasts.length"
      :podcasts="podcasts"
      :configs="v3PlayerConfigs"
      :api-resource-url="v2Player.apiResourceUrl"
    ></Player>

    <v2-player
      v-if="version === 2 && isReady"
      :mods-list="v2Player.mods"
      :dark-theme="v2Player.useDarkTheme"
      :station="v2Player.station"
      :api-resource-url="v2Player.apiResourceUrl"
      :drop-to-live="v2Player.dropToLive"
      :use-m4a="true"
    ></v2-player>

    <div
      v-if="version === 1 && isReady"
      id="widget-container"
      v-el:container
      v-bind:class="{ 'dark-theme': isDarkTheme }"
    >
      <podcast-list
        :category="currentCategory"
        :display-player-inline="displayPlayerInline"
        :drop-to-live="dropToLive"
        :container-width="containerWidth"
        :list="podcasts"
        :page-list="pageList"
        :smc="smc"
        :use-m4a="true"
      ></podcast-list>
      <categories
        v-if="mods && mods.indexOf('nocategorieslist') < 0"
        :categories="categories"
        :container-width="containerWidth"
      ></categories>
    </div>
  </div>
</template>
<script>
import PodcastList from './components/podcast_list';
import Categories from './components/categories';
import { get } from './http';
import addthis from './addthis';
import ViblastLoader from './viblast_loader';
import totangojs from './totango';

import V2Player from './v2-components/V2Player';
import Player from './v3-components/Player';

// const urlPrefix = process.env.NODE_ENV === 'production' ? `//${location.host}` : '//post.newappsdev.futurimedia.com';
const urlPrefix = 'https://postv3.futurimedia.com'; // TODO: delete this line when pushing to production

const uuid = window.name;

export default {
  components: {
    PodcastList,
    Categories,
    V2Player,
    Player,
  },
  props: ['href'],
  data() {
    return {
      version: 3,
      isReady: false,
      containerWidth: 700,
      displayPlayerInline: true,
      dropToLive: false,
      pageList: [],
      podcasts: [],
      categories: [],
      isDarkTheme: false,
      useM4a: null,
      v2Player: {
        enabled: false,
        useDarkTheme: false,
        mods: '',
        station: '',
        dropToLive: false,
        apiResourceUrl: '',
        useM4a: false,
      },
      v3PlayerConfigs: {
        mode: 'mini', // classic/mini mode
        theme: {
          // light/dark/custom theme colors
          type: 'light',
          background: null,
          text: null,
          accent: null,
        },
        preferences: {
          enableAlbumArt: true,
          enableHashtags: true,
          enableVisualization: true,
          enableShowNotes: true,
          enableGallery: true,
          galleryLimit: 7, // total number of gallery episodes to display
        },
        zone: null, // social media connection
        autoplay: 'next', // action after episode finishes continue/popup/none/autoplay
        dropToLive: false, // boolean to play live stream after episode ends
        useM4a: true, // boolean for using m4a audio. This should be hardcoded to true
      },
      smc: null,
      mods: null,
      queryParams: null,
      zone: null,
      limit: null,
      page: null,
      perPage: null,
      next: null,
      theme: null,
      shared: null,
      singlePlaylistId: null,
      sharedStation: '',
      stations: null,
      dataRequest: null,
      defaultAddthisAccount: 'ra-6171613b5ffc0150',
      hashTagModalIsVisible: false,
    };
  },
  ready() {
    if (!this.queryParams) {
      this.queryParams = this.extractQueryParams();
      this.processQueryParams();
      this.populateDataRequest();
    }
    this.informResize = this.debounce(this.informResize, 200);
    this.updateContainerWidth = this.debounce(this.updateContainerWidth, 200);
    this.updateContainerWidth();
    window.addEventListener('resize', () => this.updateContainerWidth(), false);
    addthis.onRender(() => this.informResize());
    this.loadData(this.dataRequest);
    if (!!this.stations) {
      this.stations.forEach((station) => {
        totangojs.trackStation(station.station);
      });
    }
    this.isReady = true;
  },
  methods: {
    extractQueryParams() {
      let qs = null;
      if (document && document.location && document.location.search) {
        qs = document.location.search.split('?')[1];
      } else if (!!this.href) {
        qs = this.href.split('?')[1];
      }
      if (qs) {
        return Object.assign(
          {},
          ...qs.split('&').map((s) => {
            const [k, v] = s.split('=');
            return {
              [k]: decodeURIComponent(v),
            };
          })
        );
      }

      // eslint-disable-next-line no-console
      console.log('Error: Could not find query string parameters!');
      return {};
    },
    processQueryParams() {
      this.version = Number(this.queryParams.version) || 1;
      this.zone = this.queryParams.zone;
      this.smc = this.queryParams.smc || this.zone;
      this.limit = parseInt(this.queryParams.limit || '7', 10);
      this.page = parseInt(this.queryParams.page || '1', 10);
      this.perPage = this.queryParams.perPage;
      this.next = this.queryParams.next || 'none';
      this.theme = this.queryParams.theme || 'light';
      this.isDarkTheme = this.theme === 'dark';
      this.mods = (this.queryParams.mods || '').split(',');
      this.shared = parseInt(this.queryParams.futurishared || '0', 10);
      this.singlePlaylistId = this.queryParams.id;
      this.useM4a = this.queryParams.use_m4a === 'true';

      // v3 configs
      this.v3PlayerConfigs.mode = this.queryParams.mode || 'mini';
      this.v3PlayerConfigs.theme.type = this.queryParams.theme || 'light';
      switch (this.v3PlayerConfigs.theme.type) {
        case 'dark':
          this.v3PlayerConfigs.theme.background = '#222046';
          this.v3PlayerConfigs.theme.text = '#ffffff';
          this.v3PlayerConfigs.theme.accent = '#532aa2';
          break;

        default:
          // light theme shouldn't have background/text/accent params, so they'll fallback to default
          this.v3PlayerConfigs.theme.background =
            this.validateHex(this.queryParams.background) || '#ffffff';
          this.v3PlayerConfigs.theme.text =
            this.validateHex(this.queryParams.text) || '#222046';
          this.v3PlayerConfigs.theme.accent =
            this.validateHex(this.queryParams.accent) || '#532aa2';
      }
      this.v3PlayerConfigs.preferences.enableAlbumArt =
        this.queryParams.albumart === 'true' || false;
      this.v3PlayerConfigs.preferences.enableHashtags =
        this.queryParams.hashtags === 'true' || false;
      this.v3PlayerConfigs.preferences.enableVisualization =
        this.queryParams.visualization === 'true' || false;
      this.v3PlayerConfigs.preferences.enableShowNotes =
        this.queryParams.shownotes === 'true' || false;
      this.v3PlayerConfigs.preferences.enableGallery =
        this.queryParams.gallery === 'true' || false;
      this.v3PlayerConfigs.preferences.galleryLimit =
        this.queryParams.limit || 0;
      this.v3PlayerConfigs.zone = this.queryParams.zone;
      this.v3PlayerConfigs.autoplay = this.queryParams.autoplay || 'none';
      this.v3PlayerConfigs.dropToLive = this.next === 'continue';

      if (this.shared) {
        this.sharedStation = this.queryParams.station;
      }

      this.stations = this.createStationInformation();

      this.displayPlayerInline =
        this.next === 'none' || this.next === 'continue';
      this.dropToLive = this.next === 'continue';

      this.v2Player = {
        enabled:
          this.queryParams.version &&
          parseInt(this.queryParams.version, 0) === 2,
        useDarkTheme: this.theme === 'dark',
        mods: this.queryParams.v2_mods,
        station: this.queryParams.station,
        dropToLive: this.next === 'continue',
        useM4a: this.useM4a,
        apiResourceUrl: this.buildUrl({
          station: this.queryParams.station,
          zone: this.zone,
          limit: this.limit,
          page: this.page,
          perPage: this.perPage,
        }),
      };
    },
    validateHex(hex) {
      if (!hex) return null;
      return `#${hex.replace('#', '')}`;
    },
    createStationInformation() {
      const stationlist =
        this.queryParams && this.queryParams.station
          ? this.queryParams.station
          : 'wphm';
      if (stationlist.indexOf(',') < 0) {
        return [
          {
            station: stationlist,
            zone: this.zone,
          },
        ];
      }
      return stationlist.split(',').map((stationZone) => {
        const [station, stnzone] = stationZone.split(':');
        return {
          station,
          zone: stnzone,
        };
      });
    },
    populateDataRequest() {
      this.dataRequest = this.requestAll(null, null);
      if (this.version !== 3) {
        addthis.load(this.defaultAddthisAccount, this.queryParams.src);
      }
      ViblastLoader.load();
    },
    requestAll(pageNumber, category) {
      const isMultiple = this.stations.length > 1;

      return Promise.all(
        this.stations.map((station) => {
          if (category && category.station !== station.station) {
            return {
              playlists: [],
              playlist_categories: [],
            };
          }
          const url = this.buildUrl({
            station: station.station,
            zone: station.zone,
            shared: this.shared,
            limit: this.limit,
            page: isMultiple ? null : pageNumber || this.page,
            perPage: isMultiple ? null : this.perPage,
            category: category ? category.id : null,
            id: this.singlePlaylistId,
          });

          return get(url);
        })
      );
    },
    fixKeyCase(obj) {
      const ret = {};
      Object.keys(obj).forEach((key) => {
        const fixed = key.replace(/_(.)/g, (m, $1) => $1.toUpperCase());
        ret[fixed] = obj[key];
      });
      return ret;
    },

    debounce(fn, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(this, args);
        }, wait || 100);
      };
    },

    buildUrl({ shared, zone, station, page, perPage, category, id }) {
      const categoryParam = category ? `&category=${category}` : '';
      const lstation = station ? station.toLowerCase() : '';
      const pageParam = page ? `&page=${page}` : '';
      const perPageParam = perPage ? `&perPage=${perPage}` : '';
      const sharedParam = shared ? `&include=${shared}` : '';
      const zoneParam = `&zone=${zone}`;
      const playlistIdParam = id ? `&id=${id}` : '';

      return `${urlPrefix}/${lstation}/playlist/widget.json?limit=0${zoneParam}${pageParam}${perPageParam}${sharedParam}${categoryParam}${playlistIdParam}`;
    },
    updateContainerWidth() {
      const el = this.$el || this.$els.container;
      if (el && el.scrollWidth !== this.containerWidth) {
        this.containerWidth = el.scrollWidth;
        // eslint-disable-next-line no-console
        console.log('New width:', this.containerWidth);
        this.informResize();
      }
    },

    loadData(allreqs) {
      allreqs.then((datalist) => {
        const pageList = [];

        let allcategories = [];
        let allpodcasts = [];
        let currentCategory = '';
        let sharedpodcast = null;

        this.stations.forEach(
          (station, stni) => {
            const data = datalist[stni];
            const categories = data.playlist_categories
              .map(this.fixKeyCase)
              .map((c) =>
                Object.assign(c, {
                  station: station.station,
                })
              );
            const podcasts = [];
            const playlists = data.playlists;

            for (let i = 0; i < playlists.length; i++) {
              const podcast = this.fixKeyCase(playlists[i]);
              podcast.categories = podcast.categories.map((id) => {
                let found = null;
                categories.forEach((cat) => {
                  if (+cat.id === +id) {
                    found = cat;
                  }
                });
                return found;
              });
              if (podcast.image) {
                podcast.image = `${urlPrefix}/api${podcast.image}`;
              }
              podcast.station = this.sharedStation || station.station;

              if (podcast.id === this.shared && !sharedpodcast) {
                // eslint-disable-next-line no-console
                console.log(
                  'Detected shared content:',
                  podcast.id,
                  podcast.name
                );
                podcast.shared = true;
                sharedpodcast = podcast;
              } else {
                podcast.shared = false;
                podcasts.push(podcast);
              }
            }

            /* All pagination stuff inside the for loop */
            // TODO - Abstract this into a function
            const pageCount = data.page_count;

            if (pageCount > 1) {
              for (let i = 1, l = pageCount; i <= l; i++) {
                const currentPage = data.current_page;
                const elementLimit = 5;

                // Create the content for the pagination component
                if (pageCount <= elementLimit) {
                  // Too few items to ever add a separator. Just add them all
                  pageList.push({
                    pageNumber: i,
                    classList: i === currentPage ? 'active' : '',
                  });
                } else {
                  // Need to figure out where we are in the chain to get the formatting right
                  if (currentPage > pageCount - (elementLimit - 1)) {
                    // We're almost at the end. No seperator
                    if (i >= pageCount - (elementLimit - 1)) {
                      pageList.push({
                        pageNumber: i,
                        classList: i === currentPage ? 'active' : '',
                      });
                    }
                  } else if (i === currentPage - 1 || i >= pageCount - 1) {
                    // Before the current page and after the concat item
                    pageList.push({
                      pageNumber: i,
                      classList: '',
                    });
                  } else if (i === currentPage) {
                    // Current page
                    pageList.push({
                      pageNumber: i,
                      classList: 'active',
                    });
                  } else if (currentPage === 1 && i === currentPage + 2) {
                    // We only print the current page + 2 if we're on page 1
                    pageList.push(
                      {
                        pageNumber: i,
                        classList: '',
                      },
                      {
                        pageNumber: '...',
                        classList: 'concat-item',
                      }
                    );
                  } else if (i === currentPage + 1) {
                    // We print the seperator after the current page when it's not the current page
                    if (currentPage === 1) {
                      pageList.push({
                        pageNumber: i,
                        classList: '',
                      });
                    } else {
                      pageList.push(
                        {
                          pageNumber: i,
                          classList: '',
                        },
                        {
                          pageNumber: '...',
                          classList: 'concat-item',
                        }
                      );
                    }
                  }
                }
              }
            }

            allcategories = allcategories.concat(categories);
            allpodcasts = allpodcasts.concat(podcasts);
            currentCategory = data.current_category;
          },
          (data, xhr) => {
            // eslint-disable-next-line no-console
            console.log('Unable to load:', data, xhr);
          }
        );

        allpodcasts = allpodcasts
          .sort((a, b) => {
            if (a.timestampCreated < b.timestampCreated) {
              return -1;
            }
            if (a.timestampCreated > b.timestampCreated) {
              return 1;
            }
            return 0;
          })
          .reverse();

        /**
         * Version 3 requires all podcasts loaded for the search filter to work properly
         * All other versions should limit the number of podcasts they display
         */
        if (this.version !== 3) {
          allpodcasts = allpodcasts.slice(0, this.limit);
        }

        if (sharedpodcast) {
          allpodcasts.unshift(sharedpodcast);
        }

        this.currentCategory = currentCategory;
        this.pageList = pageList;

        this.podcasts = allpodcasts;
        if (this.categories.length === 0) {
          this.categories = allcategories;
        }
      });
    },

    switchCategory(category) {
      if (category === null) {
        this.loadData(this.requestAll(1, null));
        return;
      }
      this.loadData(this.requestAll(1, category));
    },

    switchPage(pageNumber, currentCategory) {
      if (currentCategory === null) {
        this.loadData(this.requestAll(pageNumber, null));
        return;
      }
      this.loadData(this.requestAll(pageNumber, currentCategory));
    },

    imageLoaded() {
      this.informResize();
    },

    informResize() {
      if (this.version === 3) {
        const player = this.$el.querySelector('.player');

        if (!player) {
          return;
        }

        const height = player.offsetHeight;
        const width = player.offsetWidth;
        const msg = JSON.stringify({
          id: uuid,
          type: 'resize',
          height,
          width,
        });
        window.parent.postMessage(msg, '*');
        return;
      }

      if (this.version === 2) {
        const height = this.$el.querySelector(
          '.post-webwidget-v2-player-layout'
        ).offsetHeight;
        const width = this.$el.querySelector(
          '.post-webwidget-v2-player-layout'
        ).offsetWidth;
        const msg = JSON.stringify({
          id: uuid,
          type: 'resize',
          height,
          width,
        });
        window.parent.postMessage(msg, '*');
        return;
      }

      const msg = JSON.stringify({
        id: uuid,
        type: 'resize',
        width: this.$els.container.scrollWidth,
        height: this.$els.container.scrollHeight,
      });
      if (this._lastMessage !== msg) {
        this._lastMessage = msg;
        window.parent.postMessage(msg, '*');
      }
    },
    handleOnPressShowMore() {
      this.hashTagModalIsVisible = !this.hashTagModalIsVisible;
    },
  },
  watch: {
    podcasts: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.version !== 3) {
            addthis.refresh();
          }
          this.informResize();
        });
      },
    },
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
}
#widget-container {
  width: 100%;
  max-width: 700px;
}
.spacer {
  margin-bottom: 26px;
}
</style>



// WEBPACK FOOTER //
// app.vue?bae91b82